import { Component, effect, EventEmitter, inject, Input, Output } from '@angular/core';
import { RoleCardComponent } from './role-card.component';
import { CommonModule } from '@angular/common';
import { RoleExpanded, UserData, UserRole } from '@/models/user-data.model';
import { OfficeUsersService } from '@/services/app/office-users.service';

@Component({
    selector: 'app-permissions-list',
    template: `
    <div class="masonry-container">
    <h2>Assigned Roles</h2>
    <div class="masonry-item" *ngFor="let role of sortedRoles()">
      <app-role-card [role]="role"/>
    </div>
  </div>
    `,
    standalone: true,
    imports: [RoleCardComponent, CommonModule],
    styles: `
    .masonry-container {
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
      
    -webkit-column-gap: 15px;
    -moz-column-gap: 15px;
    column-gap: 15px;
  }
  
  .masonry-item {
    display: inline-block;
    width: 100%;
  }
  
  .masonry-item img {
    display:block;
    width: 100%;
  }
    `
})
export class PermissionsListComponent {
  officeList: number[] = [];
  private profile: UserData | null = null;
  @Input() size: 'small' | 'large' | 'medium' = 'large';

  officeUsersService = inject(OfficeUsersService);

  constructor(
  ) {

  }

  sortedRoles() {
    const roles = this.officeUsersService.selectedUser()?.UserRoles.filter(r => r.PermRoles.location !== true) || [];
    if (!roles) return [];

    const result: RoleExpanded[] = roles.map(role => {
      console.log('processing role', role)
      const roleName = role.PermRoles?.RoleName || "Unknown Role";
      const officeName = role.PermRoles?.Franchises?.Title || "Unknown Office";
      const userRole = role;
      const accessMap = new Map<string, string[]>();

      role.PermRoles?.RoleAccess?.forEach(access => {
        const table = access.AccessPermissions.dataTable;
        const perm = access.AccessPermissions.permType;
        if (!accessMap.has(table)) {
          accessMap.set(table, []);
        }
        accessMap.get(table)!.push(perm);
      });

      const accessArray = Array.from(accessMap.entries()).map(([table, perms]) => ({
        table,
        perms
      }));

      return {
        RoleName: roleName,
        officeName: officeName,
        userRole: userRole,
        Access: accessArray
      };
    });

    return result || [];
  }


}
